// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles__carousel___3FYpZ","wrapper":"styles__wrapper___2n3jG","container":"styles__container___Qkw5t","slot":"styles__slot___UX8jL"};